'use client';

import { useState, useEffect, useRef } from 'react';
import TableOfContents from './table-of-contents';
import type { TocItem } from '@/types/table-of-contents';

interface TocWrapperProps {
  items: TocItem[];
}

export default function TocWrapper({ items }: TocWrapperProps) {
  const [isFixed, setIsFixed] = useState(false);
  const tocRef = useRef<HTMLDivElement>(null);
  const [initialTop, setInitialTop] = useState<number>(0);

  useEffect(() => {
    // Get the initial position of the TOC
    if (tocRef.current) {
      const rect = tocRef.current.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setInitialTop(rect.top + scrollTop);
    }

    const handleScroll = () => {
      if (!tocRef.current) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const threshold = initialTop - 80; // 80px from top (equivalent to top-20)

      setIsFixed(scrollTop > threshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [initialTop]);

  return (
    <div
      ref={tocRef}
      className={`hidden lg:block w-64 ${
        isFixed ? 'fixed top-20 left-[calc(50%+400px)]' : 'absolute top-0 left-[calc(50%+400px)]'
      }`}
    >
      <TableOfContents items={items} />
    </div>
  );
}
